import Btn from '../utils/btn';

const func = $target => {
	var $removeBtn = $target.find('[data-id="btn-remove"]'),
		$atcBtn = new Btn($target.find('[data-id="btn-atc"]')),
		$errorMessage = $target.find('[data-id="error-message"]'),
		$alert = $errorMessage.find('.alert');

	$removeBtn.on('click', function(e) {
		e.preventDefault();

		var $this = $(this),
			$qty = $this.parents('.card').find('[data-id="qty"]'),
			$image = $this.parents('.card').find('.card-img-top');

		console.log($image);

		if($qty.val() == 0) {
			$image.removeClass("inactive");
			$qty.val(1);
			$this.text('Remove');
		} else {
			$image.addClass("inactive");
			$qty.val(0);
			$this.text('Select');
		}

	});

	$target.on('submit', function(e) {
		
		var $this = $(this),
			$gifts = $this.parents().find('[data-max-choice]'),
			confirmedRows = 0,
			totalOffersSelected = 0;

		$atcBtn.process();
		$alert.find('p').remove();

		$gifts.each(function() {

			var $this = $(this),
				$max = $this.data('max-choice'),
				$qty = $this.find('[data-id="qty"]'),
				totalQty = 0;

			$qty.each(function() {
				totalQty = totalQty + parseInt($(this).val());
			})

			if( (totalQty > 0) && (totalQty <= $max)) {
				confirmedRows++;
			}

			if(totalQty > 0) {
				totalOffersSelected++;
			}
			
		});

		if(($gifts.length == confirmedRows)) {
			$errorMessage.addClass('d-none');
		} else {
			e.preventDefault();
			$errorMessage.removeClass('d-none');

			if($gifts.length != totalOffersSelected) {
				$alert.append("<p>Please select a free gift for each promotion</p>");
			} else {
				$alert.append("<p>Please select the correct number of products for each promotion</p>");
			}

		}
		$atcBtn.processed();

	});
	
};

export default func;